import { render, staticRenderFns } from "./MyChild.vue?vue&type=template&id=5e90add8&scoped=true"
import script from "./MyChild.vue?vue&type=script&lang=js"
export * from "./MyChild.vue?vue&type=script&lang=js"
import style0 from "./MyChild.vue?vue&type=style&index=0&id=5e90add8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e90add8",
  null
  
)

export default component.exports